import { ChevronLeft, X } from 'lucide-react'
import type { RequirementNode } from '@ispot/shared'
import { KIND_TOKENS } from './cells'

interface Props {
  node: RequirementNode
  onClear: () => void
}

/**
 * Sticky breadcrumb shown at the top of Tree/Document views when the working
 * set is scoped to a single Initiative or Epic. Clicking "All" clears scope.
 */
export function ScopeBreadcrumb({ node, onClear }: Props) {
  const kind = KIND_TOKENS[node.type]
  return (
    <div
      className="sticky top-0 z-10 flex items-center gap-2 px-4 py-2 flex-shrink-0"
      style={{
        background: 'var(--color-warm-100)',
        borderBottom: '1px solid var(--color-border)',
        fontSize: 12.5,
      }}
    >
      <button
        onClick={onClear}
        className="inline-flex items-center gap-1 px-1.5 py-0.5 rounded font-medium"
        style={{ color: 'var(--color-fg-secondary)', background: 'transparent', border: 0, cursor: 'pointer' }}
        title="Back to all requirements"
      >
        <ChevronLeft size={12} />
        All
      </button>
      <span style={{ color: 'var(--color-fg-faint)' }}>›</span>
      <span
        className="inline-flex items-center gap-1.5 px-1.5 py-0.5 rounded font-mono"
        style={{ background: 'var(--color-warm-200)', color: kind.ink, fontSize: 10, letterSpacing: '0.05em', textTransform: 'uppercase' }}
      >
        <span aria-hidden style={{ fontWeight: 600 }}>{kind.glyph}</span>
        {kind.label}
      </span>
      <span
        className="font-medium truncate"
        style={{ color: 'var(--color-fg)', minWidth: 0 }}
      >
        {node.name}
      </span>
      <div className="flex-1" />
      <button
        onClick={onClear}
        aria-label="Clear scope"
        className="p-1 rounded"
        style={{ color: 'var(--color-fg-muted)', background: 'transparent', border: 0, cursor: 'pointer' }}
      >
        <X size={12} />
      </button>
    </div>
  )
}
